import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as SecuritySelectors from './state/selectors';
import { checkAccessInfo } from './SecurityHelpers';

class SecurityAccess extends React.Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
  };

  render() {
    const { children = () => {}, accessInfo, path } = this.props;

    const hasAccess = checkAccessInfo(accessInfo, path);
    return children(!hasAccess);
  }
}

const mapStateToProps = state => ({
  accessInfo: SecuritySelectors.getAccessInfo(state),
});

SecurityAccess = connect(mapStateToProps)(SecurityAccess);

export { SecurityAccess };



// WEBPACK FOOTER //
// ./src/common/Security/SecurityAccess.js